import PropTypes from 'prop-types';
import { getNestedTPP } from 'utils';

const {
  LANGUAGE,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app.json`);
const $TPP = require(`utils/locales/${LANGUAGE || 'tr'}.json`);

/**
 *
 * @param {object} props
 * @param {string} props.path
 * @example <TPP path='ADD_TO_BASKET_MODAL_TEXTS.KEEP_SHOPPING' />
 * @returns {string}
 */
const TPP = (props) => getNestedTPP($TPP, props.path);

TPP.propTypes = {
  path: PropTypes.string.isRequired,
};

export default TPP;



// WEBPACK FOOTER //
// ./src/hooks/TPP.js